import { Button } from '@mantine/core';
import styled from 'styled-components';
import { Box, Flex } from '../../components';
import { getColor } from '../../styles/mixins';

export const Body = styled(Flex)`
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
`;

export const FlowDiagram = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 1px solid ${getColor('gray', 200)};
`;

export const DiagramBody = styled(Flex)`
  align-items: center;
  width: 100%;
`;

export const DiagramBodyName = styled(Box)`
  text-align: left;
  color: ${getColor('gray', 100)};
  font-weight: bold;
  font-size: 20px;
`;

export const DiagramBodyTitle = styled(Box)`
  text-align: center;
  color: ${getColor('gray', 100)};
  font-weight: 600;
  font-size: 18px;
  width: 100%;
`;

export const NavigateButtons = styled(Box)`
  margin: 40px 20px;
  width: 280px;
`;

export const NavigateButton = styled(Button)`
  align-items: center;
  border-radius: 5px;
  height: 50px;
  width: 240px;
  margin: 10px 0px;
  background-color: ${getColor('cyan')};
  color: ${getColor('gray', 0)};
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: ${getColor('purple')};
  }
`;

export const NavigateButtonText = styled(Flex)`
  align-items: center;
  margin-top: 2px;
  font-size: 20px;
  font-weight: bold;
  color: ${getColor('gray', 0)};
`;
